import React, { useState } from 'react';
import { api } from '../api';
import { fmt } from '../utils';

function today() {
  return new Date().toISOString().slice(0, 10);
}

export default function LedgerSection({ deal, ledgerType, title, entries, onUpdate }) {
  const [adding, setAdding] = useState(false);
  const [form, setForm] = useState({ date: today(), description: '', amount: '' });

  const total = entries.reduce((s, e) => s + (e.amount || 0), 0);

  const handleAdd = async () => {
    if (!form.description.trim() || !form.amount) return;
    await api.addExpense(deal.id, { ledger_type: ledgerType, ...form, amount: parseFloat(form.amount) });
    setForm({ date: today(), description: '', amount: '' });
    setAdding(false);
    onUpdate();
  };

  const handleDelete = async (id) => {
    await api.deleteExpense(deal.id, id);
    onUpdate();
  };

  return (
    <div className="card deal-section">
      <div className="section-title">{title}</div>

      {entries.length === 0 && !adding && (
        <div style={{color:'var(--text-muted)',fontSize:13,marginBottom:12}}>No entries yet.</div>
      )}

      {entries.length > 0 && (
        <table className="ledger-table">
          <thead>
            <tr>
              <th style={{width:100}}>Date</th>
              <th>Description</th>
              <th style={{width:110,textAlign:'right'}}>Amount</th>
              <th style={{width:32}}></th>
            </tr>
          </thead>
          <tbody>
            {entries.map(e => (
              <tr key={e.id}>
                <td style={{color:'var(--text-muted)'}}>{e.date || '—'}</td>
                <td>{e.description}</td>
                <td style={{textAlign:'right'}} className="money">{fmt(e.amount)}</td>
                <td>
                  <button className="btn-ghost" style={{padding:'2px 6px',color:'#ccc'}} onClick={() => handleDelete(e.id)}>✕</button>
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={2} className="ledger-total">Total</td>
              <td className="ledger-total money" style={{textAlign:'right'}}>{fmt(total)}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      )}

      {adding ? (
        <div style={{display:'grid',gridTemplateColumns:'120px 1fr 110px auto auto',gap:8,marginTop:12,alignItems:'end'}}>
          <div>
            <label>Date</label>
            <input type="date" value={form.date} onChange={e => setForm(f => ({...f, date: e.target.value}))} />
          </div>
          <div>
            <label>Description</label>
            <input value={form.description} onChange={e => setForm(f => ({...f, description: e.target.value}))}
              placeholder="e.g. Roof repair" autoFocus />
          </div>
          <div>
            <label>Amount ($)</label>
            <input type="number" value={form.amount} onChange={e => setForm(f => ({...f, amount: e.target.value}))}
              placeholder="0.00"
              onKeyDown={e => e.key === 'Enter' && handleAdd()} />
          </div>
          <button className="btn-primary" style={{marginTop:20}} onClick={handleAdd}>Add</button>
          <button className="btn-secondary" style={{marginTop:20}} onClick={() => setAdding(false)}>✕</button>
        </div>
      ) : (
        <button className="add-line-btn" onClick={() => setAdding(true)}>+ Add entry</button>
      )}
    </div>
  );
}
